<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-08-22 14:41:55
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-10 17:15:35
-->
<template>
	<div class="mt-24">
		<el-button v-auth="['system:dept:create']" class="mb-12" type="primary" @click="addDepartment" plain>新增部门</el-button>
		<base-table ref="multiTable" :default-expand-all="true"  :columns="filterColumns" :list="tableList" :options="options"></base-table>
		<DepartmentDrawer ref="departmentDrawer" :originData="originData" @refresh="refresh"></DepartmentDrawer>
		<!-- 删除子部门 -->
		<el-dialog title="删除子部门" :visible.sync="disTipDialog" width="426px" class="tipDialog">
			<i class="el-icon-warning mr-6 font-h2-regular" style="color: #ff7038"></i>
			<span class="ft-14">是否确认删除该部门?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="disTipDialog = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
		<editRocendDrawer ref="editRocendDrawer" />
	</div>
</template>

<script>
import { columns } from './columns';
import { getPartnerList, delSonDep } from '@/api/teamManage';
const { checkAuth } = HOC;
export default {
	data() {
		return {
			columns,
			disTipDialog: false,
			options: {
				rowKey: 'id',
			},
			originData: [], //原始数据，未进行树形转换
			tableList: [], //转换后的树形数据
			keyList: [], //储存parentid的key值,用来匹配id,匹配不到则代表该部门没有子部门
			//涉及到删除部分的参数
			deptUserNum: 0, //部门成员
			parentDepName: '', //上级部门的名字
			depNum: 0, //下级部门数量
			depId: 0, //选中的部门id
		};
	},

	components: {
		DepartmentDrawer: () => import('./components/departmentDrawer'),
		editRocendDrawer: () => import('./components/editRocendDrawer'),
	},
	props: {},
	computed: {
		filterColumns() {
			return this.columns;
		},
	},
	created() {
		this.getPartnerList();
	},

	methods: {
		//新增部门（参数123分别表示添加子部门，编辑部门，添加部门）
		addDepartment() {
			this.$refs.departmentDrawer.show(3);
		},
		//新增子部门,上级部门是该部门名字
		addSonDep(row) {
			this.$refs.departmentDrawer.show(1, row);
		},
		//刷新列表
		async getPartnerList() {
			let data = await getPartnerList({ all: 1 });
			this.originData = data; //赋值原始数据一维数组
			// 获取所有节点的parentId的最小值作为根节点id
			const ids = data.map(item => item.id);
			const rootId = data.find(item => !ids.includes(item.parentId))?.parentId;
			data = this.arrayToTree(data, rootId, 0);
			this.tableList = data;
		},
		//转换一维数组成树形数组
		arrayToTree(data, pid, level) {
			level++;
			return data
				.filter(item => item.parentId === pid)
				.map(item => ({ ...item, children: this.arrayToTree(data, item.id, level), level, operations: this.getButtons(item, level) }));
		},
		//点击删除按钮后
		async submit() {
			const { depId } = this;
			await delSonDep(depId);
			this.$message.success('删除成功！');
			this.disTipDialog = false;
			this.getPartnerList();
		},
		opendisTipDialog(row) {
			this.deptUserNum = row.deptUserNum; //确定部门的人数，
			let parentDep = this.originData.find(item => (item.id = row.parentId));
			this.disTipDialog = true;
			this.parentDepName = parentDep.name;
			this.depId = row.id;
			this.depNum = row.children.length;
		},
		//定义一个button
		getButtons(item, level) {
			const arr = [];
			arr.push(
				{
					label: '编辑',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:dept:update'),
					fontFamily: true,
					click: checkAuth(() => {
						this.$refs.departmentDrawer.show(2, item);
					}, 'system:dept:update'),
				},
				{
					label: '新增子部门',
					type: 'text',
					isShow: level < 5 && this.$auth.hasPermi('system:dept:create'),
					classtype: 2,
					fontFamily: true,
					click: checkAuth(row => {
						this.addSonDep(row);
					}, 'system:dept:create'),
				},
				{
					label: '修改记录',
					type: 'text',
					isShow: true,
					classtype: 3,
					fontFamily: true,
					click: row => {
						this.$refs.editRocendDrawer.show(row);
					},
				},
				{
					label: '删除',
					type: 'text',
					classtype: item.deptUserNum > 0 ? 4 : 3,
					fontFamily: true,
					isShow: item.parentId !== '0' && this.$auth.hasPermi('system:dept:delete'),
					click: checkAuth(row => {
						if (item.deptUserNum > 0) return this.$message.error('不能删除该部门（原因：部门中还存在成员！）');
						this.opendisTipDialog(row);
					}, 'system:dept:delete'),
				},
			);
			return arr.filter(item => item.isShow);
		},

		//更新列表
		refresh() {
			this.getPartnerList();
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__title {
	font-size: 14px;
}

/deep/ .cell {
	display: flex;
	align-items: center;
}

/deep/ .el-icon-arrow-right:before {
	content: '\E791';
}
</style>
